import { render } from "./IpoBoardPage.vue?vue&type=template&id=5832beef&scoped=true"
import script from "./IpoBoardPage.vue?vue&type=script&lang=js"
export * from "./IpoBoardPage.vue?vue&type=script&lang=js"

import "./IpoBoardPage.vue?vue&type=style&index=0&id=5832beef&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5832beef"]])

export default __exports__